import { doLogin, LANDING_URL } from '../state';

/** Marketing site is a separate domain — leave the app to reach it. */
function goHome(): void {
  window.location.assign(LANDING_URL);
}

export function Login() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        background: '#fff',
        animation: 'nl-fade .3s ease',
      }}
    >
      {/* brand panel */}
      <div
        style={{
          flex: 1,
          background: '#f1f1f1',
          borderRight: '1px solid #e1e3e5',
          padding: '48px 56px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          minWidth: 0,
        }}
      >
        <div
          onClick={goHome}
          style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}
        >
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: 8,
              background: '#2c6ecb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{ width: 12, height: 12, border: '2.5px solid #fff', borderRadius: '50%' }}
            />
          </div>
          <span style={{ fontWeight: 800, fontSize: 18, letterSpacing: '-0.02em' }}>ScanGap</span>
        </div>
        <div style={{ maxWidth: 440 }}>
          <h2
            style={{
              fontSize: 29,
              fontWeight: 800,
              lineHeight: 1.22,
              letterSpacing: '-0.02em',
              margin: '0 0 26px',
            }}
          >
            Open is <span style={{ color: '#008060' }}>green</span>. Closed is{' '}
            <span style={{ color: '#d72c0d' }}>red</span>. One read tells you what to build.
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 11 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span
                style={{
                  width: 34,
                  height: 20,
                  borderRadius: 6,
                  background: '#e3f1df',
                  border: '1px solid #a6d9c0',
                  flexShrink: 0,
                }}
              />
              <span style={{ fontSize: 13.5, color: '#616161' }}>
                <b style={{ color: '#008060' }}>Opportunity</b> — open · unclaimed
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span
                style={{
                  width: 34,
                  height: 20,
                  borderRadius: 6,
                  background: '#fcf1cd',
                  border: '1px solid #e8d28a',
                  flexShrink: 0,
                }}
              />
              <span style={{ fontSize: 13.5, color: '#616161' }}>
                <b style={{ color: '#b98900' }}>Contested</b> — no clear leader
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span
                style={{
                  width: 34,
                  height: 20,
                  borderRadius: 6,
                  background: '#fdeae7',
                  border: '1px solid #f4c4ba',
                  flexShrink: 0,
                }}
              />
              <span style={{ fontSize: 13.5, color: '#616161' }}>
                <b style={{ color: '#d72c0d' }}>No opportunity</b> — saturated · won
              </span>
            </div>
          </div>
        </div>
        <div style={{ fontSize: 12.5, color: '#8a8a8a', fontFamily: "'JetBrains Mono'" }}>
          © 2026 ScanGap · Sample data
        </div>
      </div>
      {/* form */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 40,
        }}
      >
        <div style={{ width: '100%', maxWidth: 380 }}>
          <h1
            style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-0.02em', margin: '0 0 6px' }}
          >
            Log in
          </h1>
          <p style={{ color: '#616161', fontSize: 14.5, margin: '0 0 28px' }}>
            Continue to your niche analysis board.
          </p>
          <label
            style={{
              display: 'block',
              fontSize: 12.5,
              fontWeight: 700,
              color: '#303030',
              marginBottom: 6,
            }}
          >
            Email
          </label>
          <input
            defaultValue="dev@scangap.com"
            style={{
              width: '100%',
              height: 46,
              padding: '0 14px',
              border: '1px solid #e1e3e5',
              borderRadius: 10,
              background: '#fff',
              fontFamily: 'inherit',
              fontSize: 14,
              color: '#303030',
              outline: 'none',
              marginBottom: 16,
            }}
          />
          <label
            style={{
              display: 'block',
              fontSize: 12.5,
              fontWeight: 700,
              color: '#303030',
              marginBottom: 6,
            }}
          >
            Password
          </label>
          <input
            type="password"
            defaultValue="scangap"
            style={{
              width: '100%',
              height: 46,
              padding: '0 14px',
              border: '1px solid #e1e3e5',
              borderRadius: 10,
              background: '#fff',
              fontFamily: 'inherit',
              fontSize: 14,
              color: '#303030',
              outline: 'none',
            }}
          />
          <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '8px 0 20px' }}>
            <span style={{ fontSize: 12.5, color: '#616161', cursor: 'pointer' }}>
              Forgot password?
            </span>
          </div>
          <button
            onClick={doLogin}
            style={{
              width: '100%',
              height: 48,
              background: '#2c6ecb',
              border: 'none',
              borderRadius: 11,
              color: '#fff',
              fontFamily: 'inherit',
              fontSize: 15,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Log in →
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '20px 0' }}>
            <div style={{ flex: 1, height: 1, background: '#e1e3e5' }} />
            <span style={{ fontSize: 12, color: '#8a8a8a' }}>or</span>
            <div style={{ flex: 1, height: 1, background: '#e1e3e5' }} />
          </div>
          <button
            onClick={doLogin}
            style={{
              width: '100%',
              height: 48,
              background: '#fff',
              border: '1px solid #e1e3e5',
              borderRadius: 11,
              color: '#303030',
              fontFamily: 'inherit',
              fontSize: 14,
              fontWeight: 700,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 9,
            }}
          >
            <span
              style={{
                width: 18,
                height: 18,
                borderRadius: 5,
                background: '#2c6ecb',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <span
                style={{ width: 7, height: 7, border: '2px solid #fff', borderRadius: '50%' }}
              />
            </span>{' '}
            Continue with your marketplace
          </button>
          <p
            style={{
              textAlign: 'center',
              fontSize: 12.5,
              color: '#8a8a8a',
              margin: '22px 0 0',
              lineHeight: 1.5,
            }}
          >
            Demo — click <b style={{ color: '#303030' }}>Log in</b> to jump straight into the app.
          </p>
          <p style={{ textAlign: 'center', fontSize: 13, margin: '14px 0 0' }}>
            <span onClick={goHome} style={{ color: '#616161', cursor: 'pointer', fontWeight: 600 }}>
              ← Back to home
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
